// extracted by mini-css-extract-plugin
export default {"ageGrid":"TherapistStep5_ageGrid__dHvsR","checkboxGrid":"TherapistStep5_checkboxGrid__Kvyot","checkbox":"TherapistStep5_checkbox__5Atwn"};